import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  SidebarContainer, Logo, SidebarContent, SidebarNav,
  NavItem, NavItemIcon, NavItemText, SidebarFooter, FooterText, LogoutButton
} from './Sidebar.styles';
import { 
  UploadFile, 
  Search, 
  Description, 
  EditNote, 
  Compare, 
  Source, 
  Settings, 
  Logout, 
  TransferWithinAStation, 
  EditDocument, 
  Transcribe, 
  DocumentScanner 
} from '@mui/icons-material';
import { useAuth } from '@contexts/AuthContext';
import { useNavigate } from 'react-router-dom';


export default function Sidebar({ }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const location = useLocation();
  const navItems = [
    { icon: <UploadFile />, text: 'Collections', route: '/embed-documents' },
    { icon: <Search />, text: 'Legal Research', route: '/research' },
    { icon: <Description />, text: 'Generate Contracts', route: '/generate-contracts' },
    { icon: <EditNote />, text: 'Edit Documents', route: '/edit-documents' },
    { icon: <Compare />, text: 'Document Comparison', route: '/document-comparison' },
    { icon: <TransferWithinAStation />, text: 'Lawyer Correspondence', route: '/lawyer-correspondence' },
    { icon: <EditDocument />, text: 'Collect Workflow', route: '/wills-and-testaments' },
    { icon: <Transcribe />, text: 'Translation & Transcription', route: '/translation-transcription' },
    { icon: <DocumentScanner />, text: 'Document Extraction', route: '/doc-extract' },
    { icon: <Source />, text: 'Library', route: '/sources' },
    { icon: <Settings />, text: 'Settings', route: '/settings' },
  ];

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <>
      <SidebarContainer open={false}>
        <Logo>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <img src={'./Icons/legal-demo-Logo.png'} alt="AKINI LEGAL" style={{ width: '180px', objectFit: 'contain' }} />
          </div>
        </Logo>
        <SidebarContent>
          <SidebarNav>
            {navItems.map((item) => (
              <Link to={item.route} key={item.route}>
                <NavItem isActive={location.pathname === item.route}>
                  <NavItemIcon isActive={location.pathname === item.route}>
                    {item.icon}
                  </NavItemIcon>
                  <NavItemText isActive={location.pathname === item.route}>{item.text}</NavItemText>
                </NavItem>
              </Link>
            ))}
          </SidebarNav>
        </SidebarContent>

        <SidebarFooter>
          <LogoutButton onClick={handleLogout}>
            <Logout fontSize="small" />
              <span>Logout</span>
          </LogoutButton>
          <FooterText>© 2025 AKINI LEGAL</FooterText>
        </SidebarFooter>
      </SidebarContainer>
    </>
  );
};
